export enum AnnouncementCardTypeEnum {
	ANNOUNCEMENT = 'ANNOUNCEMENT',
	FAQ = 'FAQ'
}

export interface IAnnouncementCardProps {
	cardType: AnnouncementCardTypeEnum
}
